import styled from 'styled-components';
import { Modal } from './Modal';

export const StyledCartDeliveryModal = styled(Modal)`
  .ant-modal-content {
    margin: 0 auto 100px auto !important;
    overflow-y: auto;
    padding: 16px;
    border-radius: 8px;
    max-width: calc(100vw - 40px);

    .ant-modal-close {
      position: absolute;
      top: 1px;
      right: 1px;
      svg {
        height: 14px;
        color: ${(props) => props.theme.black};
      }
    }

    .ant-modal-footer {
      margin-top: 0;
    }
  }
`;
